import { createContext, useContext } from 'react'

/**
 * Where the move rows' popovers (slot picker, Exclude) should render
 * (z8nrz7f2gh).
 *
 * Inside the Replace dialog it is the dialog's own content element: the
 * popover stays within the modal (clickable, typeable) but above the table,
 * whose sticky Actions cells otherwise painted over it. Null elsewhere — the
 * transfer page is not a dialog, so the default portal to the body is right.
 */
export const MovePopoverContainer = createContext<HTMLElement | null>(null)

export const useMovePopoverContainer = () => useContext(MovePopoverContainer)
